export default (theme: any) => ({
    container: {
        display: "flex",
        flexFlow: "column",
        marginTop: theme.spacing(30)
    },
    logoContainer: {
        margin: "auto",
        width: "240px",
        "& > div": {
            backgroundPosition: "center"
        }
    },
    primaryText: {
        textAlign: "center",
        marginTop: theme.spacing(3),
        color: "#ccc"
    },
    secondaryText: {
        textAlign: "center",
        color: "#ccc"
    }
});
